export default __webpack_public_path__ + "static/media/icon_skill_add1.a000f260.png";